import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopBarComponent } from './top-bar.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';


@NgModule({
  declarations: [
    TopBarComponent
  ],
  imports: [
    CommonModule,

    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatDividerModule

  ],
  exports: [
    TopBarComponent
  ]
})
export class TopBarModule { }
